import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import carImg from 'images/tmp_car_image.png'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip';

const MyCarDetail = () => {

	const App = useApp()
	const [carData, setCarData] = useState()
	const [tabList, setTabList] = useState(0)
	const [guaranteeTab, setGuaranteeTab] = useState(0)
	const [showLayer, setShowLayer] = useState(false)
	const [showDetail, setShowDetail] = useState(false)
	const [showConfirm, setShowConfirm] = useState(false)

	const dataOpen = () => {
		setCarData(!carData)
	}

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const openDetail = () => {
		setShowDetail(true)
	}

	const closeDetail = () => {
		setShowDetail(false)
	}

	const openConfirm = () => {
		setShowConfirm(true)
	}

	const closeConfirm = () => {
		setShowConfirm(false)
	}


	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			{/* 내 차 정보 */}
			<div className="shadow">
				<div className="flex-justify_end padding pt_0">
					<span onClick={openConfirm} className="link-top" style={{ color: "#999" }}>삭제</span>
				</div>
				<div className="no-scroll" style={{ overflowX: "auto" }}>
					<ul className="tab-round no-wrap">
						<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>123가1234</li>
						<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>리콜정보</li>
						<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>수리・정비내역</li>
					</ul>
				</div>
				<div className="padding">
					<div className="img-box" style={{ width: "30rem", height: "13.6rem", margin: "0 auto" }}>
						<img src={carImg} alt="" />
					</div>

					{/* 차량 이미지 없을 때 */}
					<div className="center-cont no-data-box py_40 mt_10">
						<i className="icon icon_no_data" />
						<p className="mt_20">해당 차량 이미지를 찾을 수 없어요.</p>
					</div>

					<div className="car-info mt_20">
						<div>
							<span>테슬라</span>
							<span>테슬라 모델X</span>
						</div>

						{/* 차량 세부모델명 하나일 때 */}
						<p>조대리님 미래 2058년의 차 테슬라 모델X</p>

						{/* 차량 세부모델명 리스트로 나올 때 */}
						<div className={`${styles["car-name-wrap"]} ${carData ? styles.active : ""}`} onClick={dataOpen}>
							<div className="flex-justify_between align_center">
								<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
								<i className="icon icon_arrow_sm bottom gray" />
							</div>
							<div>
								<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
							</div>
						</div>

						<div className="warn-txt mt_10" onClick={openLayer}>미납 금액이 있어요.</div>

						<div className="flex-align_center mt_10">
							<span className="text-red" style={{ fontSize: "1.4rem" }}>미납 통행료 업데이트 실패</span>
							<i className="icon icon_error_update ml_5" />
						</div>
					</div>
					<div className="car-price mt_20"><strong className="text-blue">13,800</strong> 만원</div>

					<hr className="mt_20 my_30" />
					<div className="sub-guide">출시가 대비 <strong className="text-red">-13.7%</strong></div>

					{/* 그래프 영역 */}
					<div className="mt_20" style={{ height: "17.5rem", background: "#f5f5f5", padding: "0 2rem" }}></div>
					<div className="flex-justify_end mt_10" style={{ color: "#666" }}>*단위(만km)</div>

					{/* 그래프 데이터 없을 때 */}
					<div className="center-cont no-data-box py_40 mt_40">
						<i className="icon icon_no_data" />
						<p className="mt_20">데이터가 없어요.</p>
					</div>

					<div className="swiper-guide mt_20">
						<i className="icon icon_swiper_arrow mr_10" />
						<span>그래프를 좌우로 스와이프 해보세요.</span>
					</div>

					{/* case01 */}
					<div className={`${styles["my-car-info"]} mt_50`}>
						<div>
							<div className={styles.title}>
								<p>자동차검사</p>
								<i className="icon icon_arrow_sm right" />
							</div>
							<div className="pt_20">
								<div className={`${styles["day-progress"]} progress-area`}>
									<span className="progress" style={{ width: "50%" }} />
									<i className="message" style={{ left: "25%" }}>D-132</i>
								</div>
							</div>
							<ul className="mt_20">
								<li>
									<span>시작일</span>
									<span>2021.03.05</span>
								</li>
								<li>
									<span>종료일</span>
									<span>2022.03.05</span>
								</li>
							</ul>
						</div>
						<div>
							<div className={styles.title}>
								<p>DB손해보험</p>
								<i className="icon icon_arrow_sm right" />
							</div>
							<div className="pt_20">
								<div className={`${styles["day-progress"]} progress-area`}>
									<span className="progress" style={{ width: "50%" }} />
									<i className="message" style={{ left: "25%" }}>D-132</i>
								</div>
							</div>
							<ul className="mt_20">
								<li>
									<span>시작일</span>
									<span>2021.03.05</span>
								</li>
								<li>
									<span>종료일</span>
									<span>2022.03.05</span>
								</li>
							</ul>
						</div>
					</div>

					{/* case02 */}
					<div className={`${styles["my-car-info"]} mt_50`}>
						<div>
							<div className={styles.title}>
								<p>자동차검사</p>
								<i className="icon icon_arrow_sm right" />
							</div>
							<div className="pt_20">
								<div className={`${styles["day-progress"]} progress-area`}>
									<span className="progress" style={{ width: "100%", background: "#e8e8e8" }} />
									<i className="message gray right" style={{ right: 0 }}>만료</i>
								</div>
							</div>
							<ul className="mt_20">
								<li>
									<span>시작일</span>
									<span>2021.03.05</span>
								</li>
								<li>
									<span>종료일</span>
									<span>2022.03.05</span>
								</li>
							</ul>
						</div>
						<div>
							<div className={styles.title}>
								<p>자동차검사</p>
								<i className="icon icon_arrow_sm right" />
							</div>
							<div className="pt_20">
								<div className={`${styles["day-progress"]} progress-area`}>
									<span className="progress" style={{ width: "100%", background: "#e8e8e8" }} />
									<i className="message gray" style={{ left: "50%", transform: "translateX(-50%)" }}>D-?</i>
								</div>
							</div>
							<ul className="mt_20">
								<li>
									<span>시작일</span>
									<span>2021.03.05</span>
								</li>
								<li>
									<span>종료일</span>
									<span>2022.03.05</span>
								</li>
							</ul>
						</div>
					</div>

					{/* case03 */}
					<div className={`${styles["my-car-info"]} mt_50`}>
						<div>
							<div className={styles.title}>
								<p>자동차검사</p>
								<i className="icon icon_arrow_sm right" />
							</div>
							<div className="pt_20">
								<div className={`${styles["day-progress"]} progress-area`}>
									<span className="progress" style={{ width: "50%" }} />
									<i className="message" style={{ left: "25%" }}>D-132</i>
								</div>
							</div>
							<ul className="mt_20">
								<li>
									<span>시작일</span>
									<span>2021.03.05</span>
								</li>
								<li>
									<span>종료일</span>
									<span>2022.03.05</span>
								</li>
							</ul>
						</div>
						{/* 데이터 없을 때 */}
						<div>
							<div className="center-cont">
								<i className="icon icon_no_data" style={{ width: "4.2rem", height: "3.8rem" }} />
								<p className="mt_10" style={{ fontSize: "1.2rem", lineHeight: "1.8rem" }}>마이데이터 보험 정보를<br />연결해보세요.</p>
								<Button className="btn btn--md btn-more mt_20">조회하기</Button>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* 자동차세 연납 */}
			<div className="shadow">
				<div className="padding">
					<h3>1월에 자동차세를 연납한다면?</h3>
					<div className={`${styles["tax-group"]} mt_35`}>
						<span>자동차세</span>
						<div>
							<div className={styles.principal}>737,000 원</div>
							<div className="flex-align_center mt_5">
								<span className="text-blue">9.15%</span>
								<div className={`${styles.price} ml_10`}>664,000 원</div>
							</div>
						</div>
					</div>

					{/* 데이터 없을 때 */}
					<div className="center-cont mt_40">
						<i className="icon icon_no_data" />
						<p className="mt_10">자동차세 정보가 없어요.</p>
						<Button className="btn btn--big btn-more mt_30">조회하기</Button>
					</div>

				</div>
			</div>

			{/* 보증 */}
			<div className="shadow">
				<div className="padding">
					<div className="flex-align_center">
						<h3>보증</h3>
						<i className="icon icon_question ml_10" onClick={openDetail} />
					</div>
					<ul className="tab-round mt_40">
						<li onClick={() => setGuaranteeTab(0)} className={guaranteeTab === 0 ? "active" : ""}>기간 기준</li>
						<li onClick={() => setGuaranteeTab(1)} className={guaranteeTab === 1 ? "active" : ""}>주행거리 기준</li>
					</ul>
					<ul className={`${styles["bar-horizontal"]} ${styles.block} mt_40`}>
						<li>
							<div className={styles.title}>
								<strong>차체 및 일반부품</strong>
								<span>보증기간 10년</span>
							</div>
							<div className={styles["bar-area"]}>
								<div className={styles.bar}>
									<span style={{ width: "40%" }}>
										<span className={styles.percent}>3년</span>
									</span>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.title}>
								<strong>엔진 및 동력전달 주요 부품</strong>
								<span>보증기간 10년</span>
							</div>
							<div className={styles["bar-area"]}>
								<div className={styles.bar}>
									<span style={{ width: "50%" }}>
										<span className={styles.percent}>3년</span>
									</span>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.title}>
								<strong>배출가스</strong>
								<span>보증기간 10년</span>
							</div>
							<div className={styles["bar-area"]}>
								<div className={styles.bar}>
									<span style={{ width: 0, background: "#d9d9d9" }}>
										<span className={styles.percent} style={{ left: "100%", color: "#999", marginLeft: "1rem" }}>0년</span>
									</span>
								</div>
							</div>
						</li>
					</ul>

					{/* 데이터 없을 때 */}
					<div className="center-cont no-data-box mt_40 py_40">
						<i className="icon icon_no_data" />
						<p className="mt_20">데이터가 없어요.</p>
					</div>
				</div>
			</div>

			{/* 기본정보 */}
			<div className="shadow">
				<div className="padding">
					<div className="flex-justify_between align_center">
						<h3>기본정보</h3>
						<i className="icon icon_arrow_sm right icon_arrow_md" />
					</div>
					<ul className="list-item mt_35">
						<li>
							<span>연식</span>
							<span>2018년식</span>
						</li>
						<li>
							<span>배기량</span>
							<span>2,987cc</span>
						</li>
						<li>
							<span>연비</span>
							<span>9.7km/l</span>
						</li>
						<li>
							<span>연료</span>
							<span>디젤</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 옵션정보 */}
			<div className="padding">
				<div className="flex-justify_between align_center">
					<h3>옵션정보</h3>
					<i className="icon icon_arrow_sm right icon_arrow_md" />
				</div>
				<ul className="car-option mt_30">
					<li>
						<i className="icon icon_car_option icon_car_option_navi" />
						<span>내비게이션</span>
					</li>
					<li>
						<i className="icon icon_car_option icon_car_option_key active" />
						<span>스마트키</span>
					</li>
					<li>
						<i className="icon icon_car_option icon_car_option_loof active" />
						<span>선루프</span>
					</li>
					<li>
						<i className="icon icon_car_option icon_car_option_pass" />
						<span>하이패스</span>
					</li>
					<li>
						<i className="icon icon_car_option icon_car_option_camera" />
						<span>후방카메라</span>
					</li>
					<li>
						<i className="icon icon_car_option icon_car_option_view active" />
						<span>어라운드뷰</span>
					</li>
				</ul>
			</div>

			<NonpaymentLayer show={showLayer} closeLayer={closeLayer} />
			<DetailTip show={showDetail} closeLayer={closeDetail} title="보증" content="자동차보증은 보증기간 또는 주행거리 중 하나라도 충족되면 만료되요. 보증 기간은 최초 등록일을 기준으로 표시되며, 주행거리의 경우 자동차원부에 노출되는 주행거리를 기준으로 표시되어 실제와 다를 수 있으니 참고 부탁드려요." />
			<ConfirmLayer show={showConfirm} closeLayer={closeConfirm} />
		</div>
	)
}

const NonpaymentLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div className="layer-text py_10">
				차량에 현재 고속도로 통행료 미납이 발생했어요.<br />
				한국도로공사 홈페이지에서 상세 정보 확인 및 납부가<br />
				가능해요.
				<div className="mt_10 text-blue flex-align_center" style={{ fontWeight: 500 }}>
					한국도로공사 홈페이지 확인하기 <i className="icon icon_btn_arrow_blue ml_10" />
				</div>
			</div>
		</LayerBottom>
	)
}

const ConfirmLayer = ({ show, closeLayer, onClick }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<div className="btn-group">
				<Button className="btn btn--big btn-layer btn--gray" onClick={() => closeLayer()}>취소</Button>
				<Button className="btn btn--big btn-layer" onClick={onClick}>삭제하기</Button>
			</div>
		}>
			<div className="layer-text py_10">
				등록한 내 차를 삭제하시겠습니까?
			</div>
		</LayerBottom>
	)
}

export default MyCarDetail